import { Component, OnInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { DbresetService } from 'src/app/services/dbreset/dbreset.service';
import { CampaignsService } from 'src/app/services/campaigns/campaigns.service';
import { NgbModal, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { Observable, OperatorFunction, Subject, merge } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { getFirebaseBackend } from 'src/app/authUtils';
import { data } from 'jquery';
import Swal from 'sweetalert2';
import { ProspectsService } from 'src/app/services/prospects/prospects.service';

@Component({
	selector: 'app-dbreset',
	templateUrl: './dbreset.component.html',
	styleUrls: ['./dbreset.component.scss'],
})
export class DbresetComponent implements OnInit {
	ColumnMode = ColumnMode;
	SelectionType = SelectionType;

	rows: any[] = [];
	temp: any[] = [];
	selected: any[] = [];

	loadingDispos: { [index: number]: boolean } = {};
	allDispos: any[] = [];

	public user: any;

	@ViewChild('table', { static: false }) table: any;
	@ViewChild('dispos_modal', { static: true }) disposModal!: TemplateRef<any>;
	@ViewChild('campaignModal', { static: true }) campaignModal!: TemplateRef<any>;
	@ViewChild('apnmntSearch') apnmntSearch!: ElementRef;

	allColumns: any[] = [
		{ prop: 'date_generated', name: 'Appt', type: 'date', visible: true },
		{ prop: 'company_name', name: 'Company', visible: true },
		{ prop: 'employee', name: 'Employee', visible: true },
		{ prop: 'address', name: 'Address', visible: true },
		{ prop: 'primary_phone', name: 'Phone', type: 'phone', visible: true },
		{ prop: 'alias', name: 'Campaign Alias', visible: true },
		{ prop: 'client_name', name: 'Client Name', visible: true },
		{ prop: 'annual_revenue', name: 'Annual Revenue', visible: false },
		{ prop: 'employee_size', name: 'Employee Size', visible: false },
		{ prop: 'plan_assets', name: 'Plan Assets', visible: false },
		{ prop: 'plan_participants', name: 'Plan Participants', visible: false },
		{ prop: 'prospect_name', name: 'Prospect Name', visible: false },
		{ prop: 'title', name: 'Title', visible: false },
		{ prop: 'zip', name: 'Zip', visible: false },
	];

	// visibleColumns: any[] = [];

	// defaultColumns = ['date_generated', 'company_name', 'employee', 'address', 'primary_phone', 'alias', 'client_name'];

	states = [
		{ code: 'AL', name: 'Alabama' },
		{ code: 'AK', name: 'Alaska' },
		{ code: 'AZ', name: 'Arizona' },
		{ code: 'AR', name: 'Arkansas' },
		{ code: 'CA', name: 'California' },
		{ code: 'CO', name: 'Colorado' },
		{ code: 'CT', name: 'Connecticut' },
		{ code: 'DE', name: 'Delaware' },
		{ code: 'FL', name: 'Florida' },
		{ code: 'GA', name: 'Georgia' },
		{ code: 'HI', name: 'Hawaii' },
		{ code: 'ID', name: 'Idaho' },
		{ code: 'IL', name: 'Illinois' },
		{ code: 'IN', name: 'Indiana' },
		{ code: 'IA', name: 'Iowa' },
		{ code: 'KS', name: 'Kansas' },
		{ code: 'KY', name: 'Kentucky' },
		{ code: 'LA', name: 'Louisiana' },
		{ code: 'ME', name: 'Maine' },
		{ code: 'MD', name: 'Maryland' },
		{ code: 'MA', name: 'Massachusetts' },
		{ code: 'MI', name: 'Michigan' },
		{ code: 'MN', name: 'Minnesota' },
		{ code: 'MS', name: 'Mississippi' },
		{ code: 'MO', name: 'Missouri' },
		{ code: 'MT', name: 'Montana' },
		{ code: 'NE', name: 'Nebraska' },
		{ code: 'NV', name: 'Nevada' },
		{ code: 'NH', name: 'New Hampshire' },
		{ code: 'NJ', name: 'New Jersey' },
		{ code: 'NM', name: 'New Mexico' },
		{ code: 'NY', name: 'New York' },
		{ code: 'NC', name: 'North Carolina' },
		{ code: 'ND', name: 'North Dakota' },
		{ code: 'OH', name: 'Ohio' },
		{ code: 'OK', name: 'Oklahoma' },
		{ code: 'OR', name: 'Oregon' },
		{ code: 'PA', name: 'Pennsylvania' },
		{ code: 'RI', name: 'Rhode Island' },
		{ code: 'SC', name: 'South Carolina' },
		{ code: 'SD', name: 'South Dakota' },
		{ code: 'TN', name: 'Tennessee' },
		{ code: 'TX', name: 'Texas' },
		{ code: 'UT', name: 'Utah' },
		{ code: 'VT', name: 'Vermont' },
		{ code: 'VA', name: 'Virginia' },
		{ code: 'WA', name: 'Washington' },
		{ code: 'WV', name: 'West Virginia' },
		{ code: 'WI', name: 'Wisconsin' },
		{ code: 'WY', name: 'Wyoming' },
	];

	filters = {
		zip: '',
		radius: '',
		state: '',
		city: '',
	};

	public showingZipCodes = false;
	public searchs = 0;
	public searched_zips = '';

	isSearching: boolean = false;

	zipInvalid: boolean = false;

	// showingZipCodes = false;
	searchedByZipOrRadius = false;

	public campaigns: any[] = [];
	public selectedCampaign: any = '';
	public campaignSearchTerm = '';

	public selectedUserPhone: string = '';

	public isLoadingCampaigns = false;

	public isValidatingCampaign = false;

	private campaignFocus$ = new Subject<string>();
	private campaignClick$ = new Subject<string>();

	constructor(
		private DBResetSrv: DbresetService,
		private modalSrv: NgbModal,
		private campaignsSrv: CampaignsService,
		private prospectsSrv: ProspectsService,
		private router: Router,
	) {}

	ngOnInit(): void {
		//this.getLeads();
		// this.visibleColumns = this.allColumns.filter((col) => this.defaultColumns.includes(col.prop));

		this.user = getFirebaseBackend()?.getAuthenticatedUser();

		this.getCountSearches();
	}

	getLeads() {
		this.DBResetSrv.getLeads().subscribe({
			next: (res: any) => {
				this.rows = res.body;
				this.temp = [...this.rows];
			},
			error: (err) => console.error(err),
		});
	}

	updateFilter(event: any) {
		const val = event.target.value.toLowerCase();

		const filtered = this.temp.filter((row) => Object.values(row).some((v) => String(v).toLowerCase().includes(val)));

		this.rows = filtered;
	}

	onSelect({ selected }: any) {
		this.selected = [...selected];
	}

	onActivate(event: any) {
		if (event.type === 'dblclick') {
			this.openCampaignModal(event.row);
		}
	}

	search() {
		if (this.filters.zip && !/^\d{5}$/.test(this.filters.zip)) {
			Swal.fire({
				icon: 'warning',
				title: 'Invalid ZIP code',
				text: 'Please enter a valid 5-digit ZIP code.',
				confirmButtonText: 'Ok',
			});
			return;
		}

		this.searchedByZipOrRadius = !!(this.filters.zip || this.filters.radius);

		this.isSearching = true;
		this.DBResetSrv.searchDBReset(this.filters).subscribe({
			next: (res: any) => {
				this.rows = Array.isArray(res.body) ? res.body : [];
				this.temp = [...this.rows];

				this.rows = res.body.rows ?? [];
				this.searched_zips = res.body.zips ? res.body.zips.replace(/'/g, '').split(',') : [];

				this.DBResetSrv.countSearchs().subscribe({
					next: (countRes: any) => {
						this.searchs = countRes.body ?? 0;
					},
					error: (err) => {
						console.error('Error obteniendo conteo de búsquedas:', err);
					},
				});
			},
			error: (err) => console.error(err),
			complete: () => {
				this.isSearching = false;
			},
		});
	}

	openDisposModal(primary_phone: string, rowIndex: number, modal: any) {
		this.loadingDispos[rowIndex] = true;

		this.DBResetSrv.getDisposByPhone(primary_phone).subscribe({
			next: (res: any) => {
				this.allDispos = res?.body ?? res?.res ?? [];
				this.loadingDispos[rowIndex] = false;
				this.modalSrv.open(this.disposModal, { size: 'lg', centered: true });
			},
			error: () => {
				this.loadingDispos[rowIndex] = false;
			},
		});
	}

	formatPhone(phone: string): string {
		if (!phone) return '';

		const digits = phone.replace(/\D/g, '');
		if (digits.length === 10) {
			return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
		}

		return phone;
	}

	showZipCodes() {
		this.showingZipCodes = !this.showingZipCodes;
	}

	getCountSearches() {
		this.DBResetSrv.countSearchs().subscribe({
			next: (countRes: any) => {
				this.searchs = countRes.body ?? 0;
			},
			error: (err) => {
				console.error('Error obteniendo conteo de búsquedas:', err);
				this.searchs = 0;
			},
		});
	}

	onZipInput(event: any) {
		let value = event.target.value.replace(/\D/g, '');

		if (value.length > 5) {
			value = value.substring(0, 5);
		}

		this.filters.zip = value;

		if (value.length > 0 && value.length !== 5) {
			this.zipInvalid = true;
		} else {
			this.zipInvalid = false;
		}
	}

	get visibleColumns(): any[] {
		return this.allColumns.filter((col) => col.visible);
	}

	openCampaignModal(row: any) {
		this.selectedCampaign = '';
		this.campaignSearchTerm = '';
		this.selectedUserPhone = row?.primary_phone ?? '';

		this.getAssignedCampaigns();

		this.modalSrv.open(this.campaignModal, { centered: true, windowClass: 'modal-md' });
	}

	getAssignedCampaigns() {
		this.isLoadingCampaigns = true;
		return this.campaignsSrv.getCallerCampaigns(this.user?.IdUser).subscribe({
			next: (res: any) => {
				this.campaigns = res.body;
				this.isLoadingCampaigns = false;
			},
			error: (err) => {
				console.error('Error fetching campaigns:', err);
				this.isLoadingCampaigns = false;
			},
		});
	}

	searchCampaigns: OperatorFunction<string, readonly any[]> = (text$: Observable<string>) => {
		const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());

		return merge(debouncedText$, this.campaignFocus$, this.campaignClick$).pipe(map((term) => (!term ? this.campaigns : this.campaigns.filter((c) => c.name?.toLowerCase().includes(term.toLowerCase())))));
	};

	public onCampaignInputFocus(value: string) {
		this.campaignFocus$.next(value);
	}

	public onCampaignInputClick(value: string) {
		this.campaignClick$.next(value);
	}

	campaignFormatter = (campaign: any) => campaign?.name ?? '';

	public onCampaignSelected(event: NgbTypeaheadSelectItemEvent) {
		this.selectedCampaign = event.item;
	}

	openProspect() {
		if (!this.selectedCampaign || this.isValidatingCampaign) {
			return;
		}

		this.isValidatingCampaign = true;

		this.campaignsSrv.getCallerCampaigns(this.user?.IdUser).subscribe({
			next: (res: any) => {
				this.isValidatingCampaign = false;
				const freshCampaigns = res.body || [];
				this.campaigns = freshCampaigns;

				const stillValid = freshCampaigns.find((c: any) => c.id === this.selectedCampaign.id);

				if (!stillValid) {
					this.selectedCampaign = '';
					this.campaignSearchTerm = '';
					Swal.fire('⚠️', "This campaign doesn't need anymore leads", 'warning');
					return;
				}
				this.prospectsSrv.currentCampaignName = stillValid.name;

				this.modalSrv.dismissAll();
				this.router.navigateByUrl(`/prospect-info/${stillValid.id}/${stillValid.alias}/${this.selectedUserPhone}?from=dbreset`);
			},
			error: (err) => {
				this.isValidatingCampaign = false;
				console.error('Error validating campaign:', err);
				Swal.fire({
					icon: 'error',
					title: 'Error',
					text: 'Could not verify the campaign. Please try again.',
				});
			},
		});
	}
}
